<section class="visao-geral" aria-labelledby="visao-geral-titulo" data-testid="beneficios-visao-geral">
  <header class="visao-geral__topo">
    <span class="visao-geral__icone" aria-hidden="true">
      <vivest-icon name="grid" source="feather"></vivest-icon>
    </span>
    <div class="visao-geral__titulo-grupo">
      <h2 id="visao-geral-titulo" class="visao-geral__titulo">Visão Geral</h2>
      <p class="visao-geral__descricao">
        Regras de elegibilidade salvas {{ nomePlano() ? 'para o ' + nomePlano() : 'para este plano' }}.
        @if (matriz().length) {
          {{ totalAtivos() }} de {{ matriz().length }} {{ matriz().length === 1 ? 'benefício ativo' : 'benefícios ativos' }}.
        }
      </p>
    </div>
  </header>

  @if (!carregando()) {
    @if (matriz().length) {
      <ul class="visao-geral__matriz" data-testid="visao-geral-matriz">
        @for (linha of matriz(); track linha.id) {
          <li
            class="visao-geral-beneficio"
            [class.visao-geral-beneficio--inativo]="!linha.ativo"
            [attr.aria-labelledby]="'visao-geral-beneficio-' + linha.id"
            [attr.data-testid]="'visao-geral-beneficio-' + linha.id"
          >
            <div class="visao-geral-beneficio__cabecalho">
              <h3 [id]="'visao-geral-beneficio-' + linha.id" class="visao-geral-beneficio__nome">{{ linha.nome }}</h3>
              <vivest-tag type="status" [variant]="linha.ativo ? 'success' : 'warning'">
                {{ linha.ativo ? 'Ativo' : 'Inativo' }}
              </vivest-tag>
              <vivest-button
                class="visao-geral-beneficio__editar"
                variant="outline"
                size="sm"
                [attr.aria-label]="'Editar regras de ' + linha.nome"
                data-testid="visao-geral-editar"
                (click)="editar.emit(linha.id)"
              >
                <vivest-icon slot="icon-left" name="edit-2" source="feather"></vivest-icon>
                Editar regras
              </vivest-button>
            </div>

            <div class="visao-geral-beneficio__regras">
              <div class="visao-geral-beneficio__grupo">
                <p class="visao-geral-beneficio__rotulo">Elegível quando:</p>
                @if (linha.condicoes.length) {
                  <ul class="visao-geral-beneficio__itens" data-testid="visao-geral-condicoes">
                    @for (condicao of linha.condicoes; track $index) {
                      <li>{{ condicao }}</li>
                    }
                  </ul>
                } @else {
                  <p class="visao-geral-beneficio__vazio">Nenhuma condição definida.</p>
                }
              </div>

              @if (linha.excecoes) {
                <div class="visao-geral-beneficio__grupo">
                  <p class="visao-geral-beneficio__rotulo">Exceção:</p>
                  <p class="visao-geral-beneficio__texto" data-testid="visao-geral-excecoes">{{ linha.excecoes }}</p>
                </div>
              }
            </div>
          </li>
        }
      </ul>
    } @else {
      <p class="visao-geral__vazio" data-testid="visao-geral-vazio">
        Nenhum benefício configurado para este plano. Use "Elegibilidade" para adicionar os benefícios e as
        regras deles.
      </p>
    }
  }
</section>
